/* Tiroir panier VIDE : « Vous aimeriez peut-être » (Numerigram, 16/10/2026).
   Quand le tiroir s'ouvre sur un panier vide, on charge sections/sdo-tiroir-vide.liquid
   (meilleures ventes disponibles) :
   - ordinateur : panneau à gauche du tiroir, à la place de « Vous pourriez aussi aimer » ;
   - mobile : grille sous « Votre panier est vide » (le thème n'affiche pas le panneau sur mobile) ;
   - partout : le tiroir garde la forme d'un tiroir plein (barre de livraison offerte, une ligne
     « Votre panier est vide » à la place des articles, puis « Continuez vos achats »).
   Rien n'est chargé tant que le tiroir n'est pas ouvert vide (pas de requête en plus sur les pages).
   Ajout depuis le panneau : géré par le thème (product-item), format choisi par les pastilles ;
   depuis la grille : ci-dessous. */
(function () {
  if (window.__sdoTiroirVide) return;
  window.__sdoTiroirVide = true;
  var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var rendu = null, enCours = null;

  function charger() {
    if (rendu !== null) return Promise.resolve(rendu);
    if (enCours) return enCours;
    enCours = fetch(racine + '?section_id=sdo-tiroir-vide', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html');
        var pan = d.querySelector('[data-sdo-vide-panneau]');
        var grille = d.querySelector('[data-sdo-vide]');
        var haut = d.querySelector('[data-sdo-vide-haut]');
        rendu = {
          haut: haut ? haut.outerHTML : '',
          panneau: pan && pan.querySelector('product-item') ? pan.outerHTML : '',
          grille: grille && grille.querySelector('.sdo-vide__item') ? grille.outerHTML : ''
        };
        return rendu;
      })
      .catch(function () { enCours = null; return { haut: '', panneau: '', grille: '' }; });
    return enCours;
  }

  function zoneVide(cd) {
    var e = cd.querySelector('.drawer__inner-empty');
    if (!e) return null;
    return cd.classList.contains('is-empty') || !e.classList.contains('hide') ? e : null;
  }

  function poser() {
    var cd = document.querySelector('cart-drawer');
    if (!cd || !cd.classList.contains('active')) return;
    var e = zoneVide(cd);
    var inner = cd.querySelector('.drawer__inner');
    if (!e || !inner) return;
    if (e.querySelector('[data-sdo-vide-haut]') && inner.querySelector('[data-sdo-vide-panneau]') && e.querySelector('[data-sdo-vide]')) return;
    charger().then(function (r) {
      var e2 = zoneVide(cd);
      var in2 = cd.querySelector('.drawer__inner');
      if (!e2 || !in2) return;
      if (r.panneau && !in2.querySelector('[data-sdo-vide-panneau]')) {
        var tete = in2.querySelector('.drawer__header');
        if (tete) tete.insertAdjacentHTML('afterend', r.panneau); else in2.insertAdjacentHTML('afterbegin', r.panneau);
        in2.classList.add('drawer__inner--no-border');
      }
      if (r.haut && !e2.querySelector('[data-sdo-vide-haut]')) {
        e2.insertAdjacentHTML('afterbegin', r.haut);
        e2.classList.add('sdo-vide-on');
      }
      if (r.grille && !e2.querySelector('[data-sdo-vide]')) e2.insertAdjacentHTML('beforeend', r.grille);
    });
  }

  var passe = 0;
  function planifier() { if (!passe) passe = requestAnimationFrame(function () { passe = 0; poser(); }); }
  function observer() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    new MutationObserver(planifier).observe(cd, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    planifier();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observer); else observer();

  /* Pastilles de format du panneau : le format choisi est celui qu'« Ajouter » met au panier */
  document.addEventListener('click', function (ev) {
    var f = ev.target.closest && ev.target.closest('[data-sdo-format]');
    if (!f) return;
    ev.preventDefault();
    var item = f.closest('product-item');
    if (!item) return;
    [].forEach.call(item.querySelectorAll('[data-sdo-format]'), function (x) {
      var on = x === f;
      x.classList.toggle('is-on', on);
      x.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var champ = item.querySelector('form input[name="id"]');
    if (champ) champ.value = f.getAttribute('data-sdo-format');
    var prix = item.querySelector('[data-sdo-vide-prix]');
    if (prix) prix.textContent = f.getAttribute('data-prix');
  });

  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-sdo-vide-add]');
    if (!b) return;
    ev.preventDefault();
    if (b.disabled) return;
    b.disabled = true;
    var cd = document.querySelector('cart-drawer');
    var ids = cd && typeof cd.getSectionsToRender === 'function' ? cd.getSectionsToRender().map(function (s) { return s.id; }) : [];
    fetch(racine + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(b.getAttribute('data-sdo-vide-add'), 10), quantity: 1 }],
        sections: ids.join(','),
        sections_url: location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (etat) {
        if (etat && etat.sections && cd && typeof cd.renderContents === 'function') cd.renderContents(etat);
        else window.location.href = racine + 'cart';
      })
      .catch(function () { b.disabled = false; });
  });
})();
